import React, { Component } from "react";

// UI Components
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, Table, Input, Label } from "reactstrap";

// Strings
import { getMessage } from "CONFIG/i18n";

// Styles
import "./Organisations.less";
import style from "COMPONENTS/SuperAdmin/SupportCenter/Report/style.module.less";

// Images
import ic_save_icon from "ASSETS/Images/ic_save_icon.svg";
import ic_save_icon_disable from "ASSETS/Images/ic_save_icon_disable.svg";

export default class OrganisationReports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reportType: 'monthly',
      selectedYear: "",
      selectedMonth: "", 
      dropdownOpen: false,
      reportTypeDropdownOpen: false, 
      monthDropdownOpen: false,
      yearDropdownOpen: false,
      organizationData: [], 
      searchQuery: "",
      isLoading: false,
    };
  }

  componentDidMount() {
    const currentFiscalYear = this.getCurrentFiscalYear();
  
    this.setState({ 
      selectedYear: currentFiscalYear,
      selectedMonth: "01"
    });
  }

  processDailyOrganizationData = (year, month, apiData) => {
  
    const days = this.generateMonthDays(year, month);
  
    if (!apiData || !Array.isArray(apiData) || apiData.length === 0) {
      const organizationsData = this.props.organizationsData || [];
    
      return organizationsData.map(org => ({
        name: org.name,
        ...Object.fromEntries(days.map(day => [day, 0]))
      }));
    }
  
    const result = apiData.map(org => {
      const orgData = {
      // Check column name from API to retrieve correct column name otherwise use 'Unknown Organization'
        name: org.organizationName || org.name || org.customer_name || 'Unknown Organization'
      };
  
      days.forEach(day => {
      // Get data by date: If org[day] exists, use its value; otherwise, set it to 0.
        orgData[day] = org[day] !== undefined ? org[day] : 0;
      });
    
      return orgData;
    });
    return result;
  };
  
   processOrganizationData = (apiData) => {
     const months = this.generateFiscalYearMonths();
  
     if (!apiData || !Array.isArray(apiData) || apiData.length === 0) {
       const organizationsData = this.props.organizationsData || [];
    
       return organizationsData.map(org => ({
         name: org.name,
         ...Object.fromEntries(months.map(month => [month, 0]))
       }));
     }
  
     const result = apiData.map(org => {
       const orgData = {
         // Check column name from API to retrieve correct column name otherwise use 'Unknown Organization'
         name: org.organizationName || org.name || org.customer_name || 'Unknown Organization'
       };
    
       months.forEach(month => {
         orgData[month] = org[month] !== undefined ? org[month] : 0;
       });
    
       return orgData;
     });
     return result;
   };

  generateFiscalYearMonths = () => {
    const months = [];
    
    for (let month = 4; month <= 12; month++) {
      months.push(`2025/${month.toString().padStart(2, '0')}`);
    }
    
    for (let month = 1; month <= 3; month++) {
      months.push(`2026/${month.toString().padStart(2, '0')}`);
    }
    
    return months;
  };

  generateMonthDays = (year, month) => {
    if (!year || !month) {
      return [];
    }

    const days = [];
    
    const monthNum = parseInt(month, 10);
    
    const daysInMonth = new Date(year, monthNum, 0).getDate();
    
    for (let day = 1; day <= daysInMonth; day++) {
      const dayStr = day.toString().padStart(2, '0');
      days.push(`${year}/${month}/${dayStr}`);
    }
    
    return days;
  };

  getMonths = () => {
    const currentLanguage = this.props.language || localStorage.getItem('language') || 'en';
    
    const monthNames = currentLanguage === 'ja' ? [
      '1月', '2月', '3月', '4月', '5月', '6月',
      '7月', '8月', '9月', '10月', '11月', '12月'
    ] : [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    return monthNames.map((name, index) => ({
      value: String(index + 1).padStart(2, '0'),
      label: name
    }));
  };

 getYears = () => {
   const currentLanguage = this.props.language || localStorage.getItem('language') || 'en';
   const currentYear = new Date().getFullYear();
   const years = [];
  
   for (let i = 0; i < 6; i++) {
     const year = currentYear - i;
     years.push({
       value: year,
       label: currentLanguage === 'ja' ? `${year}年` : year.toString()
     });
   }
  
   return years;
 };

  getFilteredOrganizations = () => {
    const { organizationData, searchQuery } = this.state;
    
    if (!searchQuery || searchQuery.trim() === '') {
      return organizationData;
    }
    
    const query = searchQuery.toLowerCase().trim();
    return organizationData.filter(org => 
      org.name.toLowerCase().includes(query)
    );
  };

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  handleClearSearch = () => {
    this.setState({ searchQuery: "" });
  };

  getFiscalYears = () => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const fiscalYears = [];

    let fiscalYearStart = currentMonth >= 3 ? currentYear : currentYear - 1;

    for (let i = 0; i < 5; i++) {
      const startYear = fiscalYearStart - i;
      fiscalYears.push(`${startYear}`);
    }

    return fiscalYears;
  };

  toggleDropdown = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  };

  toggleReportTypeDropdown = () => {
    this.setState(prevState => ({
      reportTypeDropdownOpen: !prevState.reportTypeDropdownOpen
    }));
  };

  toggleMonthDropdown = () => {
    this.setState(prevState => ({
      monthDropdownOpen: !prevState.monthDropdownOpen
    }));
  };

  toggleYearDropdown = () => {
    this.setState(prevState => ({
      yearDropdownOpen: !prevState.yearDropdownOpen
    }));
  };

  getCurrentFiscalYear = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth(); 
    return currentMonth < 3 ? currentYear - 1 : currentYear;
  };

handleReportTypeChange = (reportType) => {
  const currentFiscalYear = this.getCurrentFiscalYear();
  const fiscalYears = this.getFiscalYears();
  
  this.setState({ 
    reportType,
    selectedYear: reportType === 'daily' ? currentFiscalYear : fiscalYears[0],
    selectedMonth: reportType === 'daily' ? "01" : "",
    organizationData: [],
  });
};

  handleYearChange = (year) => {
    this.setState({ selectedYear: year });
  };

  handleMonthChange = (month) => {
    this.setState({ selectedMonth: month });
  };

  handleDailyYearChange = (year) => {
    this.setState({ selectedYear: year });
  };

    handleFetchData = () => {
      const { reportType, selectedYear, selectedMonth } = this.state;

      if (reportType === 'monthly' && !selectedYear) return;
      if (reportType === 'daily' && (!selectedYear || !selectedMonth)) return;

      this.setState({ isLoading: true });

      const apiCall = reportType === 'monthly'
        ? this.props.getMonthlyConcurrentSessionsReport?.(selectedYear)
        : this.props.getDailyConcurrentSessionsReport?.(selectedYear, selectedMonth);

      if (!apiCall) {
        this.setState({ isLoading: false });
        return;
      }

      apiCall
      .then((response) => {
        // API responses contains either monthly or daily data depending on the report type
        const apiData = response.data?.data?.data;
        const organizationData = reportType === 'monthly'
          ? this.processOrganizationData(apiData)
          : this.processDailyOrganizationData(selectedYear, selectedMonth, apiData);
      
        this.setState({ organizationData, isLoading: false });
      })
      .catch((error) => {
        console.error(`Error fetching ${reportType} report:`, error);
        this.setState({ isLoading: false });
      });
    };

  handleDownloadReport = () => {
    const { organizationData, reportType, selectedYear, selectedMonth } = this.state;
  
    if (!organizationData || organizationData.length === 0) {
      return;
    }
  
    const columns = reportType === 'monthly' 
      ? this.generateFiscalYearMonths() 
      : this.generateMonthDays(selectedYear, selectedMonth);
  
    const escapeCSV = (value) => {
      if (value === null || value === undefined) return '0';
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      return stringValue;
    };
  
    const headers = ['Organization Name', ...columns];
    const csvRows = [
      headers.map(escapeCSV).join(','),
      ...organizationData.map(org => {
        const row = [
          org.name,
          ...columns.map(column => org[column] !== undefined ? org[column] : 0)
        ];
        return row.map(escapeCSV).join(',');
      })
    ];
  
    const csvContent = csvRows.join('\n');
  
    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  
    const filename = reportType === 'monthly'
      ? `concurrent_sessions_monthly_${selectedYear}.csv`
      : `concurrent_sessions_daily_${selectedYear}_${selectedMonth}.csv`;
  
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    }
  };

  renderConcurrentSessionsReport = () => {
    const { 
      selectedYear, 
      selectedMonth,
      dropdownOpen, 
      reportTypeDropdownOpen,
      monthDropdownOpen,
      yearDropdownOpen,
      reportType,
      searchQuery, 
      organizationData,
      isLoading
    } = this.state;
    
    const fiscalYears = this.getFiscalYears();
    
    const columns = reportType === 'monthly' 
      ? this.generateFiscalYearMonths() 
      : this.generateMonthDays(selectedYear, selectedMonth);
    
    const monthsList = this.getMonths();
    const yearsList = this.getYears();
    const filteredOrganizations = this.getFilteredOrganizations();

    const canFetch = reportType === 'monthly' 
      ? selectedYear 
      : (selectedYear && selectedMonth);

    const canDownload = reportType === 'monthly' 
      ? selectedYear 
      : (selectedYear && selectedMonth);

    return (
      <div className="contentSection">
        <div className="sectionTitle">
          {getMessage("ORGANIZATION_CONCURRENT_SESSIONS_REPORT")}
        </div>

        <div className="d-flex align-items-center justify-content-start mt-4 mb-4">
          <Dropdown isOpen={reportTypeDropdownOpen} toggle={this.toggleReportTypeDropdown} className="customDropdown">
            <DropdownToggle caret>
              {reportType === 'monthly' 
                ? getMessage("MONTHLY_CONCURRENT_SESSIONS") 
                : getMessage("DAILY_CONCURRENT_SESSIONS")}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => this.handleReportTypeChange('monthly')}>
                {getMessage("MONTHLY_CONCURRENT_SESSIONS")}
              </DropdownItem>
              <DropdownItem onClick={() => this.handleReportTypeChange('daily')}>
                {getMessage("DAILY_CONCURRENT_SESSIONS")}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>

          {reportType === 'monthly' ? (
            <Dropdown isOpen={dropdownOpen} toggle={this.toggleDropdown} className="customDropdown ml-3">
              <DropdownToggle caret>
                {selectedYear 
                  ? getMessage("CUSTOMER_DATA_YEAR", { fiscalYear: selectedYear }) 
                  : getMessage("CUSTOMER_DATA_YEAR", { fiscalYear: fiscalYears[0] })}
              </DropdownToggle>
              <DropdownMenu>
                {fiscalYears.map((year, index) => (
                  <DropdownItem 
                    key={index} 
                    value={year} 
                    onClick={() => this.handleYearChange(year)}
                  >
                    {getMessage("CUSTOMER_DATA_YEAR", { fiscalYear: year })}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          ) : (
          
            <>
              <Dropdown isOpen={yearDropdownOpen} toggle={this.toggleYearDropdown} className="customDropdown ml-3">
                <DropdownToggle caret>
                  {selectedYear 
                    ? yearsList.find(y => y.value === selectedYear)?.label 
                    : getMessage("SELECT_YEAR")}
                </DropdownToggle>
                <DropdownMenu>
                  {yearsList.map((year, index) => (
                    <DropdownItem 
                      key={index} 
                      onClick={() => this.handleDailyYearChange(year.value)}
                    >
                      {year.label}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>

              <Dropdown isOpen={monthDropdownOpen} toggle={this.toggleMonthDropdown} className="customDropdown ml-3">
                <DropdownToggle caret>
                  {selectedMonth 
                    ? monthsList.find(m => m.value === selectedMonth)?.label 
                    : monthsList[0].label}
                </DropdownToggle>
                <DropdownMenu>
                  {monthsList.map((month, index) => (
                    <DropdownItem 
                      key={index} 
                      onClick={() => this.handleMonthChange(month.value)}
                    >
                      {month.label}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </>
          )}

          <Button 
            className="fetchDataButton ml-3"
            onClick={this.handleFetchData}
            disabled={!canFetch || isLoading}
          >
            {isLoading ? getMessage("LOADING") : getMessage("GENERATE")}
          </Button>

          <Button 
            className={`${style.csvBulkExportButton} ml-3`}
            onClick={this.handleDownloadReport} 
            disabled={!organizationData || organizationData.length === 0 || isLoading}
          >
            <img
              src={(organizationData && organizationData.length > 0 && !isLoading) ? ic_save_icon : ic_save_icon_disable}
              alt={getMessage("SAVE")}
              title={getMessage("SAVE")}
            />
          </Button>
        </div>

        {organizationData && organizationData.length > 0 && (
          <Row className="noMargin mb-3">
            <Col xs={12}>
              <div className="searchContainer">
                <Label className="searchLabel">
                  {getMessage("SEARCH_ORGANIZATION")}
                </Label>
                <div className="searchInputWrapper">
                  <Input
                    type="text"
                    placeholder={getMessage("ENTER_ORGANIZATION_NAME")}
                    value={searchQuery}
                    onChange={this.handleSearchChange}
                    className="searchInput"
                  />
                  {searchQuery && (
                    <button
                      type="button"
                      onClick={this.handleClearSearch}
                      className="clearSearchButton"
                    >×
                    </button>
                  )}
                </div>
                <small className="text-muted countText">
                  {getMessage("SHOWING_X_OF_Y", { 
                    shown: filteredOrganizations.length, 
                    total: organizationData.length 
                  })}
                </small>
              </div>
            </Col>
          </Row>
        )}

        {isLoading && (
          <Row className="noMargin mt-4">
            <Col xs={12} className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">{getMessage("LOADING")}</span>
              </div>
            </Col>
          </Row>
        )}

        {!isLoading && organizationData && organizationData.length > 0 && (
          <Row className="noMargin mt-4">
            <Col xs={12}>
              {filteredOrganizations && filteredOrganizations.length > 0 ? (
                <div className="tableWrapper">
                  <Table bordered hover responsive className="organizationReportTable">
                    <thead>
                      <tr>
                        <th className="stickyColumn">
                          {getMessage("ORGANIZATION_NAME")}
                        </th>
                        {columns.map((column) => (
                          <th key={column} className="monthColumn">
                            {column}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredOrganizations.map((org, index) => (
                        <tr key={index}>
                          <td className="stickyColumn orgNameCell">
                            {org.name}
                          </td>
                          {columns.map((column) => (
                            <td key={column} className="dataCell">
                              {org[column] !== undefined ? org[column] : '-'}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <div className="emptyStateContainer">
                  <p>{getMessage("NO_ORGANIZATIONS_FOUND")}</p>
                  <Button color="link" onClick={this.handleClearSearch}>
                    {getMessage("CLEAR_FILTER")}
                  </Button>
                </div>
              )}
            </Col>
          </Row>
        )}
      </div>
    );
  };

  render() {
    return (
      this.renderConcurrentSessionsReport()
    );
  }
}